import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import configureStore from 'store/store';
import throttle from 'lodash/throttle';

import * as serviceWorker from 'services/serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import App from 'views/App';
import 'services/i18n';
import { loadState, saveState } from 'services/LocalStorageService';
import PageLoader from 'views/atoms/loader/PageLoader';
import LoadingScreen from 'views/atoms/loader/LoadingScreen';
import Auth from 'domain/auth';
import adebifyActions from 'store/adebify/actions';

import './index.scss';

// Some dynamically injected dev/runtime scripts expect `process.env`.
if (typeof window !== 'undefined' && !window.process) {
  window.process = { env: { NODE_ENV: process.env.NODE_ENV } };
}

const CHATBOT_AI_CALLBACK_PATH = '/chatbot-ai-callback';

function isChatbotAiCallbackPath() {
  const p = window.location.pathname.replace(/\/$/, '') || '/';
  return p === CHATBOT_AI_CALLBACK_PATH;
}

(async () => {
  if (isChatbotAiCallbackPath()) {
    const ChatbotAiCallback = React.lazy(() =>
      import('views/pages/chatbot-ai-callback/ChatbotAiCallback')
    );
    ReactDOM.render(
      <React.StrictMode>
        <Suspense fallback={<PageLoader />}>
          <ChatbotAiCallback />
        </Suspense>
      </React.StrictMode>,
      document.getElementById('root')
    );
    return;
  }

  ReactDOM.render(<LoadingScreen />, document.getElementById('root'));

  const user = await Auth.authentication();
  if (user) {
    const persistedState = loadState(user);
    const store = configureStore(persistedState);
    store.subscribe(
      throttle(() => {
        saveState(store.getState());
      }, 1000)
    );

    // Check adebify feature flag at session init
    store.dispatch(adebifyActions.checkAdebifyFeature());

    ReactDOM.render(
      <Provider store={store}>
        <React.StrictMode>
          <BrowserRouter>
            <Suspense fallback={<PageLoader />}>
              <App />
            </Suspense>
          </BrowserRouter>
        </React.StrictMode>
      </Provider>,
      document.getElementById('root')
    );
  }
})();
